const parentTypes = {
    email: 'E-mail',
    fb: 'Facebook',
    tm: 'Telemarketing',
    dm: 'Direct Mail',
    web: 'Web',
    google: 'Google'
};

const subTypes = {
    googleCSV: 'F6C39728-683B-48A9-BFE4-7DDC65661B61',
    dmVerzonden: 'DAE32AEB-147A-4BBE-AB80-10BFFAAF6F36',
    emailVerzonden: '95D08340-EBFC-4C63-BF77-72DE808B9869',
    telemarketing: 'BA4F1534-53F8-4FBB-A6C1-0E0F3B5B5ED9'
}

const brickTypes = {
    audience: 1,
    journey: 2,
    touchpoint: 3,
    audienceFilter: 5,
    abTest: 6,
    goal: 7
};

Object.defineProperty(brickTypes, 'isTouchpointLike', {
    //Prevent our property from showing up when enumerating over it (eg. Object.values(...))
    enumerable: false,
    value: brickType => {
        return brickType === brickTypes.touchpoint || 
            brickType === brickTypes.goal;
    }
})

export default brickTypes;

export {
    parentTypes,
    subTypes
};